import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { SquarePen } from 'lucide-react'
import { useIsAuthorized } from '~/hooks'
import { getCdmStudioUrl } from '~/shared'

type Props = {
  workspaceId: string
  botId: string
  userId: string
  className?: string
}

export const EditInStudioButton = ({ workspaceId, userId, botId, className }: Props) => {
  const isAuthorized = useIsAuthorized({ workspaceId, userId })
  const isAuthorizedToOpenStudio = isAuthorized('studio.view') || isAuthorized('studio.edit')

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={isAuthorizedToOpenStudio ? getCdmStudioUrl(botId) : ''}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
          >
            <Button className="flex w-full items-center" disabled={!isAuthorizedToOpenStudio}>
              <SquarePen />
              Edit in studio
            </Button>
          </a>
        </TooltipTrigger>
        {!isAuthorizedToOpenStudio && (
          <TooltipContent>
            <p>
              You do not have access to this feature. Contact the owner or administrator(s) of this workspace to gain
              access.
            </p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  )
}
